import { render, staticRenderFns } from "./gaoduan.vue?vue&type=template&id=f5749ce2&scoped=true&"
import script from "./gaoduan.vue?vue&type=script&lang=js&"
export * from "./gaoduan.vue?vue&type=script&lang=js&"
import style0 from "./gaoduan.vue?vue&type=style&index=0&id=f5749ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5749ce2",
  null
  
)

export default component.exports